import { render, staticRenderFns } from "./modalPoliticaPrivacidade.vue?vue&type=template&id=7c87ba15&scoped=true"
import script from "./modalPoliticaPrivacidade.vue?vue&type=script&lang=js"
export * from "./modalPoliticaPrivacidade.vue?vue&type=script&lang=js"
import style0 from "./modalPoliticaPrivacidade.vue?vue&type=style&index=0&id=7c87ba15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87ba15",
  null
  
)

export default component.exports